import { render } from "./TableDetail.vue?vue&type=template&id=1f9f6f5c"
import script from "./TableDetail.vue?vue&type=script&lang=js"
export * from "./TableDetail.vue?vue&type=script&lang=js"

import "./TableDetail.vue?vue&type=style&index=0&id=1f9f6f5c&scope=true&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__